import React from 'react';

function CopyrightTransfer() {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center fw-bold">Copyright Transfer Form</h2>
      <p>Authors must complete and submit the Copyright Transfer Form upon acceptance of their manuscript.</p>
      <div className="alert alert-info">Download the form: <a href="#">Copyright_Transfer_Form.pdf</a> (coming soon)</div>
      <h4 className="mt-4">Instructions</h4>
      <ul>
        <li>Fill out all required fields and sign the form.</li>
        <li>Upload the signed form via your account dashboard or email it to <a href="mailto:drsyedrizwanabbas@gmail.com">drsyedrizwanabbas@gmail.com</a>.</li>
      </ul>
    </div>
  );
}

export default CopyrightTransfer; 